import { render, staticRenderFns } from "./SearchResultAdmin.vue?vue&type=template&id=4f62fb10&"
import script from "./SearchResultAdmin.vue?vue&type=script&lang=js&"
export * from "./SearchResultAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports